import localForage from 'localforage';

class RsaSignaturePiecesDb {
    constructor(storeName) {
        this.storage = localForage.createInstance();
        this.storage.config({
            name: 'Lumenite-GQL',
            storeName,
        });
        this.key = storeName;
    }

    getPieces() {
        return this.storage.getItem(this.key);
    }

    updatePieces(newPieces) {
        return this.storage.setItem(this.key, newPieces || {});
    }
};

const rsaSignaturePiecesDB = new RsaSignaturePiecesDb('rsa-signature-pieces');

export default rsaSignaturePiecesDB;